<template>
  <v-container class="pt-5">
    <v-card class="mx-auto" fill-height>
      <v-card-title
        class="primary white--text headline justify-space-between"
        >{{ $t('products') }}</v-card-title
      >
      <ProductTable :url="this.$providerURL + '/Api/Catalog/GetProductList'" />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" to="/ecrmregistration">{{
          $t('back')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import ProductTable from '../components/ProductTable'
export default {
  components: {
    ProductTable
  }
}
</script>
